module.exports = __webpack_public_path__ + "static/media/pic-5.73d1a8dd.jpg";